import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-gramaticas-catecismos',
  templateUrl: './gramaticas-catecismos.component.html',
  styleUrls: ['./gramaticas-catecismos.component.scss']
})
export class GramaticasCatecismosComponent implements OnInit {

  slides = [
    { link: "https://hdl.handle.net/20.500.14428/33991", img: "/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img016.jpg", autor: "Félix Tallachini. ", titulo: "Doctrina cristiana en lengua jívara. ", ano: "Escuela Tipográfica Salesiana, 1903." },
    { link: "https://hdl.handle.net/20.500.14428/33968", img: "/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img017.jpg", autor: "Manuel Navarro. ", titulo: "Manual - quechua: para uso de los rr.pp. misioneros, de la prefectura apostólica de San Francisco de Ucayali. ", ano: "Imprenta del Estado, 1903. " },
    { link: "https://hdl.handle.net/20.500.14428/36982", img: "/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img018.jpg", autor: "Manuel Navarro. ", titulo: "Vocabulario castellano-quechua-pano: con sus respectivas gramáticas quechua y pana.", ano: "Imprenta de San Antonio, 1919." },
    { link: "https://hdl.handle.net/20.500.14428/36974", img: "/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img019.jpg", autor: "José Francisco María Ráez.", titulo: "Gramáticas en el quichua huanca y en el de Ayacucho. ", ano: "Sanmarti, 1917. " },
    { link: "https://hdl.handle.net/20.500.14428/42953", img: "/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img023.jpg", autor: "Jorge José Pacífico. ", titulo: "Melodías religiosas en quechua: seleccionadas y transcritas en su expresión típica. ", ano: "Imprenta de Herder y cía, 1924. " },
    { link: "https://hdl.handle.net/20.500.14428/42512", img: "/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img020.jpg", autor: "VV.AA.", titulo: "Catecismo breve: provincia de Tarma Nunacunapaj. ", ano: "Sanmarti, 1929. " },
    { link: "https://hdl.handle.net/20.500.14428/71656", img: "/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img021.jpg", autor: "Julian Hocquart. ", titulo: "Janacc Pacha Ñan: Devocionario, Huamanga diócesis runacunapac. ", ano: "1998" },
    { link: "https://hdl.handle.net/20.500.14428/41303", img: "/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_img022.jpg", autor: "Saturnino Pastor Feria. ", titulo: "Ejercicio de La Santa Vía-Sacra: doctrina cristiana y catecismo en el idioma qqechua.", ano: "Tipografía Cuadros, 1924. " },
  ];

  slideConfig = {
    "slidesToShow": 5, "slidesToScroll": 1, "responsive": [
      {
        'breakpoint': 800,
        'settings': {
          'slidesToShow': 1
        }
      }
    ]
  };

  constructor(private titleService: Title) {
    this.titleService.setTitle("GRAMÁTICAS, CATECISMOS Y VOCABULARIOS EN LENGUAS ORIGINARIAS");
  }

  ngOnInit(): void {
  }

}
